// src/data/faqData.js
const faqData = {
    "general": {
        "About ActiviKid": [
            {
                question: "What is ActiviKid?",
                answer: 
                    "ActiviKid is a platform and app designed for parents to explore various activities for Kids. We invite activity providers to join us as partners and post their activities on our platform. ActiviKid utilizes AI and LLM to analyze the preferences and data of your Kids, providing personalized insights to help tailor activities that best support their growth and talents."
            },
            {
                question: "Where can I find your app?",
                answer:
                    "You can Download ActiviKid from the App Store (iOS) or Google Play Store (Android).",
                answerParts: [
                    { type: 'text', value: 'You can ' },
                    { type: 'link', text: 'Download ActiviKid', path: '/download' },
                    { type: 'text', value: ' from the App Store (iOS) or Google Play Store (Android).' },
                ],
            },
        ],
        "Joining ActiviKid": [
            {
                question: "As Parents, how can I enroll in your platform?",
                answer: "You can easily create an account in our app and get started! Download ActiviKid to begin exploring. To receive the latest news from ActiviKid, kindly provide your email under \"Subscribe,\" and we’ll keep you updated.",
                answerParts: [
                    { type: 'text', value: 'You can easily create an account in our app and get started! ' },
                    { type: 'link', text: 'Download ActiviKid', path: '/download' },
                    { type: 'text', value: ' to begin exploring. To receive the latest news from ActiviKid, kindly provide your email under "Subscribe," and we’ll keep you updated.' },
                ],
            },
            {
                question: "What kind of Partners is ActiviKid looking for?",
                answer: "ActiviKid welcomes all parents who are passionate about providing the best experiences for their Kids. We seek parents who are eager to explore their children's growth with us and are committed to creating a bright future for Kids. Join us in making a positive impact!"
            },
            {
                question: "As an activity provider, how can I get in touch?",
                answer:
                    "Please fill out the form on our Discover More page, and our team will contact you as soon as possible!",
                answerParts: [
                    { type: 'text', value: 'Please fill out the form on our ' },
                    { type: 'link', text: 'Discover More', path: '/discover-more' },
                    { type: 'text', value: ' page, and our team will contact you as soon as possible!' },
                ],
            },
            {
                question: "As an activity provider, how can I join ActiviKid?",
                answer:
                    "Click Join ActiviKid under ActiviKid Partners in the navigation menu to register as a partner.",
                answerParts: [
                    { type: 'text', value: 'Click ' },
                    { type: 'link', text: 'Join ActiviKid', path: '/partner-register', newTab: true },
                    { type: 'text', value: ' under ActiviKid Partners in the navigation menu to register as a partner.' },
                ],
            },
            {
                question: "How can I contact customer service?",
                answer: "For any inquiries, please email us at cs@activikid.hk and we will get back to you as soon as possible."
            },
        ]
    },
    "profile-management": {
      "My Account": [
        {
          question: "How do I change the language of my account?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
        {
          question: "How do I change my name on my Activikid account?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
      ],
      "My Profiles": [
        {
          question: "Can I set up multiple profiles for different kids?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
        {
          question: "Is a guardian required to create a profile for my kid?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
      ],
      "Activity Preferences": [
        {
          question:
            "Can I specify areas for improvement for my kid in the activity preferences?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
        {
          question:
            "Is there a limit to how much detail I can provide about my kid's preferences?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
      ],
      "Credits and Purchases": [
        {
          question: "What are credits in Activikid?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
        {
          question: "How do I earn credits on my account?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
      ],
    },
    "search-and-filtering": {
        "Search": [
            {
                question: "How do I use the keyword search feature to find courses?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "What types of keywords can I enter in the search bar?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],
        "Filtering": [
            {
                question: "How do I filter courses based on age preferences?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "What options are available for promotional discounts?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ]

    },
    "activities-details": {
        "Activity Overview": [
            {
                question: "What types of activities are available on Activikid?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "What types of activities are available on Activikid?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],
        "Like and Saved Activities": [
            {
                question: "What does 'liking' a course do?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "How do I 'like' a course to save it for later?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],
        "Instructor Information": [
            {
                question: "How can I find out who will be teaching my kid's activity?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "What qualifications do the instructors have?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],
        "Location and Facilities": [
            {
                question: "Where are the activities held?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "Are the facilities safe and kid-friendly?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],
        "Safety and Policies": [
            {
                question: "What safety measures are in place during activities?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "How does Activikid handle allergies or medical conditions?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],

    },
    "booking-schedule": {
        "Booking Reservations": [
            {
                question: "Can I see a list of available options for my kid's activities?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "A reservation I want for my kid is booked. Is there a waitlist available?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],
        "Managing bookings": [
            {
                question: "How can I view my kid's current bookings?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "Can I modify my kid's booking after it has been confirmed?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ],
        "Cancelling bookings": [
            {
                question: "What is the cancellation policy for my kid's reservations?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            },
            {
                question: "How far in advance do I need to cancel a reservation?",
                answer: "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon."
            }
        ]
    },
    "reviews&comments": {
      "Leaving a Review": [
        {
          question: "How do I leave a review for my kid's class?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
        {
          question: "Are there guidelines for writing a review?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
      ],
      "Reading Reviews": [
        {
          question: "Where can I find reviews for specific classes?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
        {
          question: "Can I filter reviews by rating or date?",
          answer:
            "Please stay tuned for ActiviKid's updates on the launch date! We can’t wait to share more information with you soon.",
        },
      ],
    },
  };

const launchUpdateZh = "請密切留意 ActiviKid 的最新消息，我們很快會公布更多詳情。";

const faqCategoryTranslations = {
    "general": {
        "About ActiviKid": "關於 ActiviKid",
        "Joining ActiviKid": "加入 ActiviKid",
    },
    "profile-management": {
        "My Account": "我的帳戶",
        "My Profiles": "我的個人檔案",
        "Activity Preferences": "活動偏好設定",
        "Credits and Purchases": "積分及購買",
    },
    "search-and-filtering": {
        "Search": "搜尋",
        "Filtering": "篩選",
    },
    "activities-details": {
        "Activity Overview": "活動概覽",
        "Like and Saved Activities": "收藏及已儲存活動",
        "Instructor Information": "導師資料",
        "Location and Facilities": "地點及設施",
        "Safety and Policies": "安全及政策",
    },
    "booking-schedule": {
        "Booking Reservations": "預約活動",
        "Managing bookings": "管理預約",
        "Cancelling bookings": "取消預約",
    },
    "reviews&comments": {
        "Leaving a Review": "撰寫評價",
        "Reading Reviews": "查看評價",
    },
};

const faqItemTranslations = {
    "general": {
        "About ActiviKid": [
            {
                question: "甚麼是 ActiviKid？",
                answer: "ActiviKid 是一個專為家長而設的平台及應用程式，協助家長探索不同的兒童活動。我們亦歡迎活動供應商成為合作夥伴，在平台上發布活動。ActiviKid 會運用 AI 及大型語言模型分析孩子的喜好和資料，提供個人化建議，協助家長選擇更適合孩子成長及發展潛能的活動。",
            },
            {
                question: "在哪裡可以下載你們的應用程式？",
                answer: "你可以從 App Store（iOS）或 Google Play Store（Android）下載 ActiviKid。",
                answerParts: [
                    { type: 'text', value: '你可以從 App Store（iOS）或 Google Play Store（Android）' },
                    { type: 'link', text: '下載 ActiviKid', path: '/download' },
                    { type: 'text', value: '。' },
                ],
            },
        ],
        "Joining ActiviKid": [
            {
                question: "作為家長，我可以如何加入你們的平台？",
                answer: "你可以在應用程式內輕鬆建立帳戶並開始使用！立即下載 ActiviKid 開始探索。如想收到 ActiviKid 的最新消息，請在頁尾「訂閱」欄位留下你的電郵，我們會持續為你提供最新資訊。",
                answerParts: [
                    { type: 'text', value: '你可以在應用程式內輕鬆建立帳戶並開始使用！立即' },
                    { type: 'link', text: '下載 ActiviKid', path: '/download' },
                    { type: 'text', value: ' 開始探索。如想收到 ActiviKid 的最新消息，請在頁尾「訂閱」欄位留下你的電郵，我們會持續為你提供最新資訊。' },
                ],
            },
            {
                question: "ActiviKid 正在尋找什樣的合作夥伴？",
                answer: "ActiviKid 歡迎所有熱衷於為孩子提供最佳體驗的家長。我們希望找到樂意與我們一同探索孩子成長歷程，並致力為孩子創造美好未來的家長。立即加入我們，一同帶來正面影響！",
            },
            {
                question: "作為活動供應商，我可以如何聯絡你們了解更多？",
                answer: "請填寫「探索更多」頁面上的表格，我們的團隊會盡快與您聯絡。",
                answerParts: [
                    { type: 'text', value: '請填寫「' },
                    { type: 'link', text: '探索更多', path: '/discover-more' },
                    { type: 'text', value: '」頁面上的表格，我們的團隊會盡快與您聯絡。' },
                ],
            },
            {
                question: "作為活動供應商，我可以如何加入 ActiviKid？",
                answer: "請按「加入 ActiviKid」，即可登記成為合作夥伴。",
                answerParts: [
                    { type: 'text', value: '請按「' },
                    { type: 'link', text: '加入 ActiviKid', path: '/partner-register', newTab: true },
                    { type: 'text', value: '」，即可登記成為合作夥伴。您亦可在導覽列的「合作夥伴」下找到此連結。' },
                ],
            },
            {
                question: "我可以如何聯絡客戶服務？",
                answer: "如有任何查詢，請電郵至 cs@activikid.hk，我們會盡快回覆您。",
            },
        ],
    },
    "profile-management": {
        "My Account": [
            { question: "如何更改帳戶語言？", answer: launchUpdateZh },
            { question: "如何更改 ActiviKid 帳戶上的姓名？", answer: launchUpdateZh },
        ],
        "My Profiles": [
            { question: "我可以為不同孩子建立多個個人檔案嗎？", answer: launchUpdateZh },
            { question: "建立孩子個人檔案時是否需要監護人？", answer: launchUpdateZh },
        ],
        "Activity Preferences": [
            { question: "我可以在活動偏好設定中列明孩子希望改善的範疇嗎？", answer: launchUpdateZh },
            { question: "我可以提供多少關於孩子偏好的資料？", answer: launchUpdateZh },
        ],
        "Credits and Purchases": [
            { question: "ActiviKid 的積分是甚麼？", answer: launchUpdateZh },
            { question: "我可以如何賺取帳戶積分？", answer: launchUpdateZh },
        ],
    },
    "search-and-filtering": {
        "Search": [
            { question: "如何使用關鍵字搜尋功能尋找課程？", answer: launchUpdateZh },
            { question: "我可以在搜尋欄輸入甚麼類型的關鍵字？", answer: launchUpdateZh },
        ],
        "Filtering": [
            { question: "如何按年齡偏好篩選課程？", answer: launchUpdateZh },
            { question: "有哪些優惠折扣選項可供選擇？", answer: launchUpdateZh },
        ],
    },
    "activities-details": {
        "Activity Overview": [
            { question: "ActiviKid 上有哪些類型的活動？", answer: launchUpdateZh },
            { question: "ActiviKid 提供哪些活動類別？", answer: launchUpdateZh },
        ],
        "Like and Saved Activities": [
            { question: "「收藏」課程有甚麼作用？", answer: launchUpdateZh },
            { question: "如何收藏課程以便稍後查看？", answer: launchUpdateZh },
        ],
        "Instructor Information": [
            { question: "如何查看孩子活動的導師資料？", answer: launchUpdateZh },
            { question: "導師具備甚麼資格？", answer: launchUpdateZh },
        ],
        "Location and Facilities": [
            { question: "活動會在哪裡舉行？", answer: launchUpdateZh },
            { question: "場地設施是否安全及適合兒童？", answer: launchUpdateZh },
        ],
        "Safety and Policies": [
            { question: "活動期間有哪些安全措施？", answer: launchUpdateZh },
            { question: "ActiviKid 如何處理過敏或健康狀況？", answer: launchUpdateZh },
        ],
    },
    "booking-schedule": {
        "Booking Reservations": [
            { question: "我可以查看適合孩子活動的可選項目嗎？", answer: launchUpdateZh },
            { question: "如想預約的活動已滿，會有候補名單嗎？", answer: launchUpdateZh },
        ],
        "Managing bookings": [
            { question: "如何查看孩子目前的預約？", answer: launchUpdateZh },
            { question: "預約確認後，我可以修改孩子的預約嗎？", answer: launchUpdateZh },
        ],
        "Cancelling bookings": [
            { question: "孩子活動預約的取消政策是甚麼？", answer: launchUpdateZh },
            { question: "我需要提前多久取消預約？", answer: launchUpdateZh },
        ],
    },
    "reviews&comments": {
        "Leaving a Review": [
            { question: "如何為孩子的課堂撰寫評價？", answer: launchUpdateZh },
            { question: "撰寫評價有甚麼指引？", answer: launchUpdateZh },
        ],
        "Reading Reviews": [
            { question: "在哪裡可以查看特定課堂的評價？", answer: launchUpdateZh },
            { question: "我可以按評分或日期篩選評價嗎？", answer: launchUpdateZh },
        ],
    },
};

export const getLocalizedFaqData = (language) => {
    if (!language || !language.startsWith('zh')) {
        return faqData;
    }

    return Object.entries(faqData).reduce((localizedSections, [section, categories]) => {
        localizedSections[section] = Object.entries(categories).reduce((localizedCategories, [category, faqs]) => {
            const localizedCategory = faqCategoryTranslations[section]?.[category] || category;
            const localizedFaqs = faqs.map((faq, index) => ({
                ...faq,
                ...(faqItemTranslations[section]?.[category]?.[index] || {}),
            }));

            localizedCategories[localizedCategory] = localizedFaqs;
            return localizedCategories;
        }, {});

        return localizedSections;
    }, {});
};

export default faqData;
  